import React from 'react';

const WhatsAppButton = () => {
  const phoneNumber = '9459457733'; // WhatsApp number (945 945 7733)
  const message = 'Hello, I am interested in your tour packages.';

  const handleWhatsAppClick = () => {
    const encodedMessage = encodeURIComponent(message);
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <a
      href="#"
      className="whatsapp-button"
      onClick={(e) => {
        e.preventDefault();
        handleWhatsAppClick();
      }}
      aria-label="Contact us on WhatsApp"
    >
      <i className="fab fa-whatsapp"></i>
    </a>
  );
};

export default WhatsAppButton;
